const productTileTemplate = item => {
	const bemBlock = 'product-lister-item';
	// TODO: Ideally the outline structure of this block should be generated by productListerItem.tag
	// TODO: Either productListerItem.tag should be renamed to productTile.tag or this file should become productListerItemTemplate.js
	/* eslint no-underscore-dangle: 0 */
	return `
		<div
			class="${bemBlock} ${bemBlock}--basicInfo align-items-start"
			data-article-number="${item.productId || ''}"
			data-legacy-sku="${item.legacyProductId || ''}"
			data-query-id="${item.__queryID || ''}"
			data-ranking="${item.ranking || ''}"
			data-product-title="${item.productTitle || ''}"
			data-product-id="${item.productId || ''}"
			data-product-name="${item.productTitle || ''}"
			data-stock-status="${item.stock?.inStock ? 'inStock' : 'outOfStock'}"
			data-sku-category-hierarchy="${item.categoryHierarchies ? Object.values(item.categoryHierarchies).join(' | ') : ''}"
			data-sku-category-name="${item.categoryHierarchiesCode?.join('/') || ''}"
			data-sku-item-category="${item.categoryHierarchiesCode[0] || ''}"
			data-sku-item-category2="${item.categoryHierarchiesCode[1] || ''}"
			data-sku-item-category3="${item.categoryHierarchiesCode[2] || ''}"
			data-gtm-tracking-type="gtm_product_view"
			data-gtm-data-store="true"
		>
			<div class="${bemBlock}__prefix-actions"></div>
			
			<div class="${bemBlock}__product-image">
				<a class="${bemBlock}__thumb " href="/${item.pageLanguage}${item.productUrl}?queryID=${item.__queryID}" data-gtm-tracking-type="gtm_product_click" data-gtm-bubble-up-for-data="true">
					${item.cdnImageHtml}
				</a>    
			</div>
			<div class="${bemBlock}__content">
				<div class="${bemBlock}__force-full-height">
					<div class="${bemBlock}__energy-rating">
						${item.energyRatingHtml}
					</div>
					<div class="${bemBlock}__product-name">
						<div class="${bemBlock}__info">
							<a class="${bemBlock}__name" href="/${item.pageLanguage}${item.productUrl}?queryID=${item.__queryID}" data-gtm-tracking-type="gtm_product_click" data-gtm-bubble-up-for-data="true">
								${item.productTitle}
							</a>                   
							<div class="${bemBlock}__rating"></div>      
						</div>
					</div>
					<div class="${bemBlock}__product-info">
						<div class="${bemBlock}__price">
							${item.pricePanelHtml}
						</div>
						<div class="${bemBlock}__pricing-table">
							${item.productPriceTableHtml}	
						</div>
					</div>
					<div class="${bemBlock}__stock-info">
						<div class="${bemBlock}__stock-message">
							${item.stockInfoHtml}
						</div>
					</div>
					<div class="${bemBlock}__actions">
						<div class="${bemBlock}__add-to-cart-panel">
							${item.productAddToCartHtml}
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
};
export default productTileTemplate;
